import { Actions, createEffect, ofType } from '@ngrx/effects';
import { inject } from '@angular/core';
import { catchError, map, of, switchMap, withLatestFrom } from 'rxjs';
import {
  ExternalCameraService,
} from '../../services/project-external-camera.service';
import { ProjectExternalCameraActions } from '../state/plan-external-camera/project-external-camera.actions';
import { Store } from '@ngrx/store';
import { projectExternalCameraFeature } from '../state/plan-external-camera/project-external-camera.feature';

export const loadExternalCameraBrands = createEffect(
  (actions$ = inject(Actions), cameraService = inject(ExternalCameraService)) => {
    return actions$.pipe(
      ofType(ProjectExternalCameraActions.loadExternalCameraBrands),
      switchMap(() => {
        return cameraService.getExternalCameraBrands().pipe(
          map((brands) =>
            ProjectExternalCameraActions.loadExternalCameraBrandsSuccess(
              { brands },
            ),
          ),
          catchError(() =>
            of(ProjectExternalCameraActions.loadExternalCameraBrandsFail()),
          ),
        );
      }),
    );
  },
  { functional: true },
);

export const loadFilteredExternalCameras = createEffect(
  (actions$ = inject(Actions),
    cameraService = inject(ExternalCameraService),
    store$ = inject(Store)) => {
    return actions$.pipe(
      ofType(ProjectExternalCameraActions.loadFilteredExternalCameras),
      withLatestFrom(
        store$.select(projectExternalCameraFeature.selectPage),
        store$.select(projectExternalCameraFeature.selectPerPage),
        store$.select(projectExternalCameraFeature.selectFilters),
        store$.select(projectExternalCameraFeature.selectIsLastPage)
      ),
      switchMap(([, page, perPage, filters, isLastPage]) => {
        if (isLastPage) {
          return of(ProjectExternalCameraActions.resetStateOnLastPage());
        }

        return cameraService.getExternalCameras(page, perPage, filters).pipe(
          map((result) =>
            ProjectExternalCameraActions.loadFilteredExternalCamerasSuccess(
              { cameras: result.items },
            ),
          ),
          catchError(() =>
            of(ProjectExternalCameraActions.loadFilteredExternalCamerasFail()),
          ),
        );
      }),
    );
  },
  { functional: true },
);

export const loadExternalCameraTypes = createEffect(
  (actions$ = inject(Actions), cameraService = inject(ExternalCameraService)) => {
    return actions$.pipe(
      ofType(ProjectExternalCameraActions.loadExternalCameraTypes),
      switchMap(() => {
        return cameraService.getExternalCameraTypes().pipe(
          map((types) =>
            ProjectExternalCameraActions.loadExternalCameraTypesSuccess(
              { types: types },
            ),
          ),
          catchError(() =>
            of(ProjectExternalCameraActions.loadExternalCameraTypesFail()),
          ),
        );
      }),
    );
  },
  { functional: true },
);

export const filterTrigger = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(ProjectExternalCameraActions.setExternalCameraFilters),
      switchMap(() => {
        return [
          ProjectExternalCameraActions.resetList(),
          ProjectExternalCameraActions.loadFilteredExternalCameras(),
        ]
      }),
    );
  },
  { functional: true },
);
